"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import React from "react";
import { WaveLeaderboardGridItem } from "./WaveLeaderboardGridItem";
export type WaveLeaderboardGridMode = "compact" | "content_only";
interface WaveLeaderboardGridProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly mode: WaveLeaderboardGridMode;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly curatedByGroupId?: string | undefined;
}
export const WaveLeaderboardGrid: React.FC<WaveLeaderboardGridProps> = t0 => {
  const $ = _c(20);
  const {
    wave,
    sort,
    mode,
    onDropClick,
    curatedByGroupId
  } = t0;
  let t1;
  if ($[0] !== curatedByGroupId || $[1] !== sort || $[2] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort,
      curatedByGroupId
    };
    $[0] = curatedByGroupId;
    $[1] = sort;
    $[2] = wave.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  if (isFetching && drops.length === 0) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="tw-@container"><div className="tw-grid tw-gap-4 @lg:tw-grid-cols-2 @3xl:tw-grid-cols-3">{Array.from({
            length: 6
          }).map(_temp)}</div></div>;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (drops.length === 0) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="tw-flex tw-h-32 tw-items-center tw-justify-center tw-text-sm tw-text-iron-500">No drops to show</div>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== drops || $[7] !== mode || $[8] !== onDropClick) {
    let t3;
    if ($[10] !== mode || $[11] !== onDropClick) {
      t3 = drop => <WaveLeaderboardGridItem key={drop.id} drop={drop} mode={mode} onDropClick={onDropClick} />;
      $[10] = mode;
      $[11] = onDropClick;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = drops.map(t3);
    $[6] = drops;
    $[7] = mode;
    $[8] = onDropClick;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[13] !== fetchNextPage || $[14] !== hasNextPage || $[15] !== isFetchingNextPage) {
    t3 = hasNextPage && <div className="tw-col-span-full tw-mb-2 tw-mt-4 tw-flex tw-justify-center"><button onClick={() => fetchNextPage()} disabled={isFetchingNextPage} className="tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900 tw-px-4 tw-py-2 tw-text-sm tw-text-iron-400 tw-transition desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-300">{isFetchingNextPage ? "Loading more..." : "Load more drops"}</button></div>;
    $[13] = fetchNextPage;
    $[14] = hasNextPage;
    $[15] = isFetchingNextPage;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t2 || $[18] !== t3) {
    t4 = <div className="tw-@container"><div className="tw-grid tw-gap-4 @lg:tw-grid-cols-2 @3xl:tw-grid-cols-3">{t2}{t3}</div></div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
function _temp(_, i) {
  return <div key={i} className="tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-iron-800/60 tw-bg-iron-950"><div className="tw-aspect-[16/9] tw-min-h-[14rem] tw-animate-pulse tw-bg-iron-900/80 md:tw-min-h-[15rem]" /><div className="tw-space-y-2 tw-px-3 tw-py-3"><div className="tw-h-4 tw-w-3/4 tw-rounded tw-animate-pulse tw-bg-iron-800/50" /><div className="tw-h-3 tw-w-1/3 tw-rounded tw-animate-pulse tw-bg-iron-800/40" /></div></div>;
}